import React from 'react';

export default function MetricsBar() {
  const metrics = [
    { value: '10k+', label: 'Stworzonych rzutów' },
    { value: '98%', label: 'Zadowolonych klientów' },
    { value: '< 5 min', label: 'Średni czas przygotowania projektu' },
    { value: '24/7', label: 'Dostępność kreatora' }
  ];

  return (
    <section className="border-b border-gray-200/60 bg-white">
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-200/60 border-x border-gray-200/60">
          {metrics.map((metric, index) => (
            <div key={index} className="py-8 px-6 flex flex-col items-center text-center">
              <div className="text-2xl sm:text-3xl font-semibold text-[#1F2937] mb-1 tracking-tight">{metric.value}</div>
              <div className="text-[13px] font-medium text-gray-500 uppercase tracking-wider">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}